module.exports = __webpack_public_path__ + "media/images/subject_img/COMPUTER SCIENCE-SOFTWARE ENGINEERING-fb8b3812593a67dd474df439fe7b70e5.jpg";